import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN } from '@sleepstation/const'
import { propToMarginTop } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import SecondaryFooter from './SecondaryFooter'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout)`
  position: relative;
  z-index: 1;
  ${propToMarginTop(`margin`)}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const SiteFooterMinimal = ({
  margin,
  termsAndConditionsPath,
  privacyPolicyPath,
  informationStandardPath,
}) => {
  const legalPages = [
    {
      title: `Terms`,
      path: termsAndConditionsPath,
    },
    {
      title: `Privacy`,
      path: privacyPolicyPath,
    },
  ]

  return (
    <Layout as="footer" margin={margin} align={LAYOUT_ALIGN.STRECH}>
      <SecondaryFooter
        legalPages={legalPages}
        informationStandardPath={informationStandardPath}
      />
    </Layout>
  )
}

SiteFooterMinimal.propTypes = {
  margin: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  termsAndConditionsPath: PropTypes.string,
  privacyPolicyPath: PropTypes.string,
  informationStandardPath: PropTypes.string,
}

SiteFooterMinimal.defaultProps = {
  margin: 3,
  termsAndConditionsPath: undefined,
  privacyPolicyPath: undefined,
  informationStandardPath: undefined,
}

export default SiteFooterMinimal
